import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

export interface States {
  currency: string;
  isTestingProcessModalShown: boolean;
}

export interface Actions {
  setCurrency: (currency: string) => void;
  setIsTestingProcessModalShown: (isTestingProcessModalShown: boolean) => void;
}

export const useStore = create(
  persist<States & Actions>(
    (set) => ({
      currency: "USD",
      setCurrency: (currency) => set({ currency }),
      isTestingProcessModalShown: false,
      setIsTestingProcessModalShown: (isTestingProcessModalShown) => set({ isTestingProcessModalShown })
    }),
    {
      name: "travelthru-store_v1",
      version: 2,
      storage: createJSONStorage(() => {
        // Make sure localStorage is available (SSR check)
        if (typeof window !== 'undefined') {
          return localStorage;
        }
        return {
          getItem: () => null,
          setItem: () => { },
          removeItem: () => { }
        };
      }),
    }
  )
);